import React from 'react'
import { Link } from 'gatsby'
import styled from 'styled-components'
import {
  calculateResponsiveSize,
  calculateMobileResponsiveSize,
  mediaMax,
} from 'styles/media-queries'

export const MenuWrap = styled.div`
  height: 100dvh;
  width: 50%;
  position: fixed;
  background: var(--black);
  color: #fff;
  top: 0;
  right: 0;
  padding: ${calculateResponsiveSize(30)} ${calculateResponsiveSize(40)}
    ${calculateResponsiveSize(30)} ${calculateResponsiveSize(83)};
  transition: 0.8s;
  transition-timing-function: linear;
  z-index: 8;

  display: flex;
  flex-direction: column;
  transform: translateX(100%);
  .opened.menu & {
    transform: translateX(0%);
  }

  ${mediaMax('mobile')} {
    width: 100%;
    transition: 1s;
    transition-timing-function: linear;

    padding: ${calculateMobileResponsiveSize(40)}
      ${calculateMobileResponsiveSize(36)} ${calculateMobileResponsiveSize(40)}
      ${calculateMobileResponsiveSize(36)};
    .opened.contact & {
      transform: translateX(-100%);
    }
  }
`
export const CenterContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin: auto 0;
  transition: transform 0.8s 0s;
  transform: translateX(100%);
  transition-timing-function: linear;

  .opened.menu & {
    transform: translateX(0%);
    transition: transform 0.8s 0s;
    transition-timing-function: linear;
  }

  ${mediaMax('mobile')} {
    transition: 0s;
    transform: translateX(0%);
  }
`

export const Left = styled.div`
  width: 50%;
  transition: 0.8s;
  transition-timing-function: linear;

  background: var(--black);
  position: fixed;
  z-index: 8;
  left: 0;
  top: 0;
  bottom: 0;
  height: 100dvh;

  overflow: hidden;
  transform: translateX(-100%);
  .opened.menu & {
    transform: translateX(0%);
  }
  ${mediaMax('mobile')} {
    display: none;
  }
`
export const BText = styled.div`
  position: absolute;
  bottom: ${calculateResponsiveSize(30)};
  left: ${calculateResponsiveSize(30)};
  transition: transform 0.8s 0s;
  transform: translateX(-100%);
  transition-timing-function: linear;

  .opened.menu & {
    transform: translateX(0%);
    transition: transform 0.8s 0s;
    transition-timing-function: linear;
  }
  ${mediaMax('mobile')} {
    transition: 0s;
    transform: translateX(0%);
  }
`
export const Creative = styled.div`
  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 400;
  line-height: ${calculateResponsiveSize(16)};
  letter-spacing: ${calculateResponsiveSize(2)};
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-transform: uppercase;
  color: var(--light);
`
export const Copyright = styled.div`
  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 400;
  line-height: ${calculateResponsiveSize(16)};
  letter-spacing: ${calculateResponsiveSize(2)};
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  text-transform: uppercase;

  color: var(--light);
`

export const Item = styled((props) => <Link {...props} />)`
  color: var(--light);
  &:hover,
  &:active,
  &:visited {
    color: var(--light);
    text-decoration: none;
  }
  display: flex;
  font-family: 'Canela';
  font-size: ${calculateResponsiveSize(42)};
  font-weight: 250;
  line-height: ${calculateResponsiveSize(50.4)};
  letter-spacing: -0.01em;
  text-align: left;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
  transition: 0.5s;

  &.secondary {
    font-family: 'Basis Grotesque';
    font-size: ${calculateResponsiveSize(12)};
    font-weight: 400;
    line-height: ${calculateResponsiveSize(19 / 2)};
  }

  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(42)};
    line-height: ${calculateMobileResponsiveSize(50.4)};
    &.secondary {
      font-size: ${calculateMobileResponsiveSize(12)};
      line-height: ${calculateMobileResponsiveSize(19 / 2)};
    }
  }
`

export const Primary = styled.ul`
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: flex-start;
  justify-content: center;
  gap: ${calculateResponsiveSize(21)};
`
export const Secondary = styled.ul`
  display: flex;
  flex: 1;
  align-items: center;
  gap: ${calculateResponsiveSize(14)};
  margin-top: ${calculateResponsiveSize(0)};
  height: ${calculateResponsiveSize(0)};
  opacity: 0;
  transform: translateY(${calculateResponsiveSize(14)});
  overflow: hidden;
  transition: 0.5s;
  ${mediaMax('mobile')} {
    gap: ${calculateMobileResponsiveSize(14)};
    height: ${calculateMobileResponsiveSize(0)} !important;
    &.mobile-open {
      height: ${calculateMobileResponsiveSize(14)} !important;
      margin-top: ${calculateMobileResponsiveSize(10)} !important;
      opacity: 1;
      transform: translateY(0);
    }
  }
`
export const Li = styled.li`
  position: relative;
  &:hover ${Secondary} {
    height: ${calculateResponsiveSize(14)};
    margin-top: ${calculateResponsiveSize(10)};
    opacity: 1;
    transform: translateY(0);
  }
  &.primary:before {
    content: '';
    display: flex;
    width: ${calculateResponsiveSize(9)};
    height: ${calculateResponsiveSize(9)};
    border-radius: 50%;
    background: var(--light);
    position: absolute;
    top: ${calculateResponsiveSize(30)};
    left: -${calculateResponsiveSize(18)};
    transition: 0.5s;
    transform: scale(0);
  }
  &.primary:hover:before {
    top: ${calculateResponsiveSize(17)};
    left: -${calculateResponsiveSize(18)};
    transform: scale(1);
  }
  &.no-hover {
    ${Item} {
      opacity: 0.5;
    }
  }

  &.primary.no-pr-hover {
    ${Item} {
      opacity: 0.5;
    }
  }
  ${mediaMax('mobile')} {
    &.primary:before {
      width: ${calculateMobileResponsiveSize(9)};
      height: ${calculateMobileResponsiveSize(9)};
    }
    &.primary:hover:before {
      top: ${calculateMobileResponsiveSize(17)};
      left: -${calculateMobileResponsiveSize(18)};
      transform: scale(1);
    }
  }
`
export const Links = styled.div``
export const Bottom = styled.div`
  font-family: 'Basis Grotesque Pro';
  font-size: ${calculateResponsiveSize(10)};
  font-weight: 400;
  line-height: 0;
  letter-spacing: ${calculateResponsiveSize(2)};
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  text-transform: uppercase;

  a,
  a:hover,
  a:active,
  a:visited {
    color: #fff;
  }
  display: flex;
  align-items: center;
  gap: ${calculateResponsiveSize(18)};
  margin-top: ${calculateResponsiveSize(35)};

  & div div {
    color: #ededed80;
    padding-top: ${calculateResponsiveSize(2)};
  }
  & span {
    width: ${calculateResponsiveSize(1)};
    height: ${calculateResponsiveSize(16)};
    background: #ededed80;
  }

  ${mediaMax('mobile')} {
    font-size: ${calculateMobileResponsiveSize(10)};
    letter-spacing: ${calculateMobileResponsiveSize(2)};
    gap: ${calculateMobileResponsiveSize(18)};
    margin-top: ${calculateMobileResponsiveSize(35)};

    & div div {
      padding-top: ${calculateResponsiveSize(2)};
    }
    & span {
      width: ${calculateMobileResponsiveSize(1)};
      height: ${calculateMobileResponsiveSize(16)};
    }
  }
`
export const MobileLinkContact = styled.button`
  display: none;
  ${mediaMax('mobile')} {
    display: flex;
    font-family: 'Basis Grotesque Pro';
    font-size: ${calculateMobileResponsiveSize(10)};
    font-weight: 400;
    line-height: 0;
    letter-spacing: ${calculateMobileResponsiveSize(2)};
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;

    text-transform: uppercase;
    color: #fff;
    border: none;
  }
`
